class ApiMigrateSiteMessageMessage {
  constructor(
    public user_id: string,
    public account_id: string,
    public sub_domain: string,
  ) {}
}

export class ApiSiteMigrateMessage {
  constructor(
    private _accountId: string,
    private _subDomain: string,
    private _userId?: string,
  ) {}

  get subDomain(): string {
    return this._subDomain;
  }

  get accountId(): string {
    return this._accountId;
  }

  get userId(): string {
    return this._userId;
  }

  public toApi(): ApiMigrateSiteMessageMessage {
    return new ApiMigrateSiteMessageMessage(this.userId, this.accountId, this.subDomain);
  }
}

export interface ApiMigrateSiteResponseJSON {
  data: ApiMigrateSiteResponse;
}

interface ApiMigrateSiteResponse {
  site_id: string;
  job_id: string;
}

export class ApiSiteMigrateResponse {
  constructor(
    private _siteId: string,
    private _jobId: string,
  ) {}

  get jobId(): string {
    return this._jobId;
  }

  get siteId(): string {
    return this._siteId;
  }

  public static fromApi(createResponse: ApiMigrateSiteResponse): ApiSiteMigrateResponse {
    return new ApiSiteMigrateResponse(createResponse.site_id, createResponse.job_id);
  }
}
